const GA_PV_TRACKING_SESSION_KEY = 'GA_PV_TRACKING_SESSION_KEY'

export function isStorageSupported(type: 'localStorage'): boolean {
  try {
    const storage = window[type]
    const testKey = '__storage_test__'

    storage.setItem(testKey, '1')
    storage.removeItem(testKey)

    return true
  } catch (error) {
    return false
  }
}

// Minimal in-memory mock for WebStorage APIs
export class StorageClass {
  storage: {
    [key: string]: string | null
  } = {}

  setItem = (key: string, data: string): void => {
    const json = (data && data.toString()) || null

    this.storage[key] = json
  }

  getItem = (key: string): string => this.storage[key] || ''

  removeItem = (key: string) => {
    delete this.storage[key]
  }

  clear = () => {
    this.storage = new StorageClass().storage
  }
}

export const LocalStorage = isStorageSupported('localStorage')
  ? window.localStorage
  : new StorageClass()

const getLocalStorage = (key: string): string | null => {
  try {
    const res = localStorage.getItem(key)
    return res
  } catch (e) {
    return null
  }
}

export const deleteLocalStorage = (key: string) => {
  try {
    localStorage.removeItem(key)
  } catch (e) {
    // Error case if required
  }
}

export const setLocalStorage = (key: string, data: string) => {
  try {
    localStorage.setItem(key, data)
  } catch (e) {
    // Error case if required
  }
}

export function checkPreviousPageExists() {
  return !!getLocalStorage(GA_PV_TRACKING_SESSION_KEY)
}

export function setPreviousPageExists(value: string) {
  return setLocalStorage(GA_PV_TRACKING_SESSION_KEY, value)
}
